/**
 * Preloads for the sign-in screen (ADR-WES1).
 *
 * The auth client and the console are lazy chunks. Loaded on demand, a
 * sign-in would chain them: submit -> auth client chunk -> sign-in request ->
 * session -> console chunks. Instead the auth screen fetches the auth client as
 * soon as it opens (every submit needs it, and the visitor is typing), and a
 * sign-in submit starts the console chunks alongside the sign-in request.
 * Only hints: a failed preload is retried by the loader that needs it.
 */
import { consoleChunks } from "./console-loaders";
import { preloadSupabaseAuth } from "./supabase";

/** The sign-in / sign-up screen is open. */
export function preloadForAuthScreen(): void {
  preloadSupabaseAuth();
}

/** A sign-in was submitted: the console is next. */
export function preloadConsoleForSignIn(): void {
  void consoleChunks.surface().catch(() => {
    // ConsoleSurface's lazy loader retries and reports the failure.
  });
}
